var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-sidebar"},[_c('ul',_vm._l((_vm.menus),function(item,i){return _c('div',{key:i},[(!item.hidden)?_c('li',{class:_vm.activeMenu(item),on:{"click":function($event){return _vm.executeRouter(item)}}},[_c('div',{staticClass:"base-sidebar__label"},[_vm._v(_vm._s(item.label))])]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }